import { Box, Heading, HStack, Image, Text } from "@chakra-ui/react";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";

export const Luxury = () => {
  return (
    <Box textAlign={"center"} mt={"20px"} pt={"50px"} bgColor={"white"} pb={"20vh"}>
      <Heading>UC Luxury Experience</Heading>
      <Text as={"small"} fontWeight={"light"} pb={"50px"}>
        Top Professional | Best Brands | Premium Experience
      </Text>
      <HStack width={"60%"} margin={"auto"} mt={"16vh"} gap={"20px"}>
        <Box alignItems={"center"} width={"23%"}>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1631883165804-025664.png"
            }
            borderRadius={"5px"}
            width={"100%"}
          />
          <Text>Salon Luxe</Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1631883164057-dd5910.png"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Salon for Men Royal</Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1631883164904-165c1e.png"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Spa Luxe</Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Image
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1631883164502-08f9f6.png"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Massage Therpay For Men Royale</Text>
        </Box>
      </HStack>
    </Box>
  );
};
